import { render, staticRenderFns } from "./editWorkV2.vue?vue&type=template&id=5a2ac93b"
import script from "./editWorkV2.vue?vue&type=script&lang=js"
export * from "./editWorkV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports